import { Badge, type BadgeVariant } from '@/components/ui/Badge'
import { STATUS_LABEL, type ReferralPublicStatus } from '@/services/referralsService'

const VARIANT: Record<ReferralPublicStatus, BadgeVariant> = {
  recebido: 'info',
  em_contato: 'info',
  reuniao: 'default',
  proposta: 'warning',
  ganho: 'success',
  perdido: 'danger',
  comissao_pendente: 'warning',
  comissao_liberada: 'default',
  pago: 'success',
}

export function ParceirosStatusBadge({ status }: { status: ReferralPublicStatus }) {
  return <Badge variant={VARIANT[status]}>{STATUS_LABEL[status]}</Badge>
}
